export const AMENDMENT = 7;

export const FINAL_EDITED = 4;
export const FINAL_EDITED_SENT = 6;
export const FINAL = 8;
export const BUDGET = null;

export const pettyCashConstText = {
  [FINAL_EDITED]: "ارسال نشده",
  [FINAL_EDITED_SENT]: "ارسال شده",
  [AMENDMENT]: "اصلاحی"
};

export const CustodianImprestStateText = {
  [FINAL_EDITED]: "ارسال نشده",
  [FINAL_EDITED_SENT]: "ارسال شده",
  [FINAL]: "قطعی شده",
  [BUDGET]: "بودجه بندی"
};

export const MANAGER_CHANGE_STATE_MODES = {
  RETURN: "return",
  REJECT: "reject",
  REJECT_FINALIZE: "reject-finalize",
  FINALIZE: "finalize",
  APPROVE: "approve"
};

export const CUSTODIAN_NOT_VARIABLE_IMPREST_CONFIRM = (state, actionName) => {
  switch (state) {
    case FINAL:
      return `${actionName} تنخواه قطعی شده امکان‌پذیر نمی‌باشد. برای این منظور باید مدیر شرکت تنخواه قطعی شده را از حالت قطعی خارج و بازگشت بدهند.`;
    case FINAL_EDITED_SENT:
      return `امکان ${actionName} تنخواه ارسال شده وجود ندارد. برای این منظور باید مدیر شرکت تنخواه ارسال شده را بازگشت بدهد.`;
  }
};

export const PETTY_CASH_CONFIRM_ACCEPT_ACTION = {
  NOT_CHANGEABLE: "NOT_CHANGEABLE",
  CHANGEABLE: "CHANGEABLE",
  CONFIRM_FOR_DELETE_NON_LAST: "CONFIRM_FOR_DELETE_NON_LAST",
  CONFIRM_FOR_EDIT_NON_LAST: "CONFIRM_FOR_EDIT_NON_LAST",
  SEND_SURE: "SEND_SURE",
  SEND_SHARE: "SEND_SHARE",
  SEND_ORDER: "SEND_ORDER",
  RETURN_SURE: "RETURN_SURE",
  MANAGER_FINALIZE: "MANAGER_FINALIZE"
};

export const PETTY_CASH_ACTION = {
  DEL: "DEL",
  EDT: "EDT"
};

export const ACTION_NAMES = {
  [PETTY_CASH_ACTION.DEL]: "حذف",
  [PETTY_CASH_ACTION.EDT]: "ویرایش"
};

export const CUSTODIAN_CONFIRM_FOR_CHANGE_STATE = type => {
  if (type === PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_SHARE) {
    return `قابلیت ارسال تنخواه زمانی استفاده می‌شود که از شرکت به صورت اشتراکی بین چندین کاربر استفاده شود. پیشنهاد می‌کنیم درصورتی که بصورت شخصی و تک کاربره از تنخواه‌گردان استفاده می‌کنید، از این قابلیت استفاده ننمایید. آیا همچنان می‌خواهید تنخواه خود را به پنل مدیریت ارسال کنید؟`;
  } else if (type === PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_ORDER) {
    return `برای ارسال تنخواه به مدیر باید گزارش‌های تنخواه به ترتیب ارسال شوند.`;
  } else if (type === PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_SURE) {
    return `آیا از ارسال این گزارش مطمئن هستید؟ گزارشات تنخواه ارسال شده، تنها بعد از دریافت دسترسی از مدیریت، امکان ویرایش یا حذف را خواهند داشت.`;
  } else if (type === PETTY_CASH_CONFIRM_ACCEPT_ACTION.RETURN_SURE) {
    return `آیا از بازگشت تنخواه مطمئن هستید؟`;
  }
};

export const CUSTODIAN_CHANGE_STATE_MODES = {
  RETURN: "return",
  SEND: "send",
  REQUEST_RETURN: "request-return"
};

export const FIELDS = {
  TRANSACS: { name: "transactions", initial: [] },
  START_DATE: { name: "start_date", initial: "" },
  END_DATE: { name: "end_date", initial: "" },
  DESCRIPTION: { name: "description", initial: "" },
  IMPREST_NUMBER: { name: "imprest_number", initial: "" }
};

export const NOT_VARIABLE_PETTY_CASH_CONFIRM = (state, isEdit) => {
  const action = isEdit ? "ویرایش" : "حذف";
  if (state === FINAL_EDITED_SENT) {
    return `امکان ${action} تنخواه ارسال شده وجود ندارد.`;
  }
  if (state === AMENDMENT) {
    return `${action} تنخواه اصلاحی فقط توسط مدیر امکان پذیر است.`;
  }
};

export const CONFIRM_TYPE = {
  SEND_SURE: 0,
  SEND_SHARE: 1,
  SEND_ORDER: 2,
  RETURN_SURE: 3,
  RETURN_JUST_LAST: 4,
  ASK_RETURN_SURE: 5,
  MANAGER_RETURN: 6
};

export const CONFIRM_FOR_RETURN_OR_SEND = type => {
  if (type === CONFIRM_TYPE.SEND_SHARE) {
    return `قابلیت ارسال تنخواه زمانی استفاده می‌شود که از شرکت به صورت اشتراکی بین چندین کاربر استفاده شود. پیشنهاد می‌کنیم درصورتی که بصورت شخصی و تک کاربره از تنخواه‌گردان استفاده می‌کنید، از این قابلیت استفاده ننمایید. آیا همچنان می‌خواهید تنخواه خود را به پنل مدیریت ارسال کنید؟`;
  } else if (type === CONFIRM_TYPE.SEND_ORDER) {
    return `برای ارسال تنخواه به مدیر باید گزارش‌های تنخواه به ترتیب ارسال شوند.`;
  } else if (type === CONFIRM_TYPE.SEND_SURE) {
    return `آیا از ارسال این گزارش مطمئن هستید؟ گزارشات تنخواه ارسال شده، تنها بعد از دریافت دسترسی از مدیریت، امکان ویرایش یا حذف را خواهند داشت.`;
  } else if (type === CONFIRM_TYPE.RETURN_SURE) {
    return `آیا از بازگشت تنخواه مطمئن هستید؟`;
  } else if (type === CONFIRM_TYPE.RETURN_JUST_LAST) {
    return `تنها بازگشت آخرین تنخواه ارسال‌شده امکان پذیر است.`;
  } else if (type === CONFIRM_TYPE.ASK_RETURN_SURE) {
    return `آیا از درخواست بازگشت تنخواه توسط مدیر مطمئن هستید؟`;
  } else if (type === CONFIRM_TYPE.MANAGER_RETURN) {
    return `آیا از بازگشت تنخواه مطمئن هستید؟`;
  }
};

export const MANAGER_IMPREST_STATES = {
  WITHOUT_PETTY_CASH: 1,
  NOT_SENT: 2,
  WAIT_FOR_OTHERS: 3,
  WAIT_FOR_ME: 4,
  CONFIRMED: 5,
  WAIT_FOR_FINALIZED: 6,
  FINALIZED: 7
};

export const ManagerImprestStateText = {
  [MANAGER_IMPREST_STATES.WAIT_FOR_ME]: "در انتظار تایید من",
  [MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED]: "در انتظار قطعی سازی",
  [MANAGER_IMPREST_STATES.CONFIRMED]: "تایید شده",
  [MANAGER_IMPREST_STATES.FINALIZED]: "قطعی شده",
  [MANAGER_IMPREST_STATES.WAIT_FOR_OTHERS]: "در انتظار تایید دیگران",
  [MANAGER_IMPREST_STATES.NOT_SENT]: "ارسال نشده",
  [MANAGER_IMPREST_STATES.WITHOUT_PETTY_CASH]: "بدون تنخواه"
};

export const MANAGER_NOT_VARIABLE_IMPREST_CONFIRM = (
  state,
  hasConfirmedByLoginUser
) => {
  switch (state) {
    case MANAGER_IMPREST_STATES.NOT_SENT:
      return `این تنخواه هنوز توسط تنخواه‌دار ارسال نشده است. برای تایید تنخواه ابتدا باید تنخواه‌دار آن را ارسال کند.`;
    case MANAGER_IMPREST_STATES.CONFIRMED:
      const approver = hasConfirmedByLoginUser ? "شما" : "سایر مدیران";
      return `این تنخواه توسط ${approver} تایید شده است. برای ویرایش آن لازم است سایر مدیران از پنل مدیریتی خود این تنخواه را بازگشت دهند.`;
    case MANAGER_IMPREST_STATES.FINALIZED:
      return `این تنخواه قطعی شده است. برای خروج از حالت قطعی سازی باید سایر مدیران از پنل مدیریتی خود این تنخواه را به حالت عدم قطعی سازی تغییر دهند.`;
    case MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED:
      return `شما در هیچ سطح تایید این تیم تنخواه‌داری حضور ندارید. برای این منظور از مالک یا ادمین شرکت بخواهید تنظیمات سطح تایید این تیم تنخواه‌داری را تغییر دهند.`;
  }
};

export const STATE_ENUM = {
  TRANSACTION_CREATE: 1,
  TRANSACTION_UPDATE: 2,
  TRANSACTION_DATE_UPDATE: 3,

  IMPREST_SEND: 4,
  IMPREST_APPROVE: 5,
  IMPREST_REJECT: 6,
  IMPREST_RETURN: 7,
  IMPREST_FINALIZE: 8,
  IMPREST_REJECT_FINALIZE: 9,
  IMPREST_REQUEST_RETURN: 10
};

export const MANAGER_CONFIRM_FOR_CHANGE_STATE = type => {
  if (type === PETTY_CASH_CONFIRM_ACCEPT_ACTION.MANAGER_FINALIZE) {
    return `با قطعی کردن تنخواه امکان ویرایش و حذف تنخواه وجود نخواهد داشت و برای این منظور باید ابتدا گزارش تنخواه را از حالت قطعی خارج کنید و سپس ویرایش کنید. از قطعی کردن این تنخواه اطمینان دارید؟`;
  }
};

export const MANAGER_NO_ACTION_MESSAGE = (state, hasConfirmedByLoginUser) => {
  switch (state) {
    case MANAGER_IMPREST_STATES.FINALIZED:
      return "این تنخواه قطعی شده است. برای خروج از حالت قطعی‌سازی باید سایر مدیران از پنل مدیریتی خود این تنخواه را به حالت عدم قطعی‌سازی تغییر دهند.";
    case MANAGER_IMPREST_STATES.WAIT_FOR_FINALIZED:
      return "شما دسترسی لازم جهت تغییر وضعیت تنخواه را ندارید.";
    case MANAGER_IMPREST_STATES.NOT_SENT:
      return "این تنخواه هنوز توسط تنخواه‌دار ارسال نشده است. برای تایید تنخواه ابتدا باید تنخواه‌دار آن را ارسال کند.";
    case MANAGER_IMPREST_STATES.CONFIRMED:
      const approvedBy = hasConfirmedByLoginUser ? "شما" : "سایر مدیران";
      return `این تنخواه توسط ${approvedBy} تایید شده است. برای ویرایش آن لازم است سایر مدیران از پنل مدیریتی خود این تنخواه را بازگشت دهند.`;
  }
};
